module.exports = __webpack_public_path__ + "static/media/lkk.3ceff927.svg";